var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 12.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 30.5984C24.5111 30.5984 30.6 24.5095 30.6 16.9984C30.6 9.48737 24.5111 3.39844 17 3.39844C9.48895 3.39844 3.40002 9.48737 3.40002 16.9984C3.40002 24.5095 9.48895 30.5984 17 30.5984ZM23.3021 14.8005C23.966 14.1366 23.966 13.0602 23.3021 12.3964C22.6382 11.7325 21.5618 11.7325 20.8979 12.3964L15.3 17.9943L13.1021 15.7964C12.4382 15.1325 11.3618 15.1325 10.6979 15.7964C10.0341 16.4602 10.0341 17.5366 10.6979 18.2005L14.0979 21.6005C14.7618 22.2644 15.8382 22.2644 16.5021 21.6005L23.3021 14.8005Z",
    fill: "#00E19A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.add2a37880fdb3bc493bb630fc1bb786.svg";
export { ForwardRef as ReactComponent };